import { noticeContent } from 'src/constants'
import { takeEvery, put, call } from 'redux-saga/effects'
import { actions } from '../../BootstrapSlice'
import { stringHash } from 'src/utils'

/**
 * Logs debug information for bootstrap notice processes.
 *
 * @param {string} flow - The bootstrap flow being executed.
 * @param {string} action - The action being performed.
 * @param {Object} [details={}] - Additional details to log (optional, defaults to empty object).
 *
 * @returns {void}
 */
const debugLog = (flow, action, details = {}) => {
  console.debug(`[Bootstrap-Notice: ${flow}] ${action}`, details)
}

/**
 * Handles the notice visibility and hash management using session cookies.
 *
 * @param {Function} services - Service container function
 *
 * @returns {void}
 */
export function* noticeHandler(services) {
  const Session = services('Session')
  let savedNoticeVisibility = yield call(
    [Session, 'getCookie'],
    'USER_NOTICE_DISPLAY'
  )
  let savedNoticeHash = yield call([Session, 'getCookie'], 'USER_NOTICE_HASH')
  let noticeVisibility =
    savedNoticeVisibility || savedNoticeVisibility === undefined
  const currentNoticeHash = stringHash(noticeContent)
  if (savedNoticeHash !== currentNoticeHash) {
    yield call([Session, 'setCookie'], 'USER_NOTICE_HASH', currentNoticeHash)
    noticeVisibility = true
  }
  yield put(actions.setNoticeVisibility(noticeVisibility))
}

/**
 * Sets the visibility state for user notices and saves it to a cookie
 *
 * @param {Object} services - Service container to access Session service
 * @param {Object} action - Redux action object
 *
 * @throws {Error} When unable to set cookie
 * @returns {void}
 */
export function* setNoticeVisibility(services, action) {
  debugLog('notice', 'Setting visibility state', {
    visibility: action.payload
  })

  try {
    const Session = services('Session')
    const { payload: visibility } = action

    yield call([Session, 'setCookie'], 'USER_NOTICE_DISPLAY', visibility)
    debugLog('notice', 'Visibility saved to cookie')
  } catch (error) {
    debugLog('notice', 'Failed to set visibility', {
      error: error.message,
      stack: error.stack
    })
  }
}

export default function* watchInitialize(services) {
  yield takeEvery(actions.setNoticeVisibility, setNoticeVisibility, services)
}
